import React, { useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faPlus, faCog } from '@fortawesome/free-solid-svg-icons';
import AppContext from 'context/Context';
import ManageShortcutsModal from './ManageShortcutsModal';

const TicketQuickCommands = ({ onSelectCommand, commands = [], onReload }) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div
      className="px-3 py-1 border-top d-flex align-items-center gap-2 overflow-x-auto"
      style={{
        backgroundColor: isDark ? '#121e2d' : '#f8fafc',
        borderColor: isDark ? '#233142' : '#e2e8f0'
      }}
    >
      <small
        className="d-flex align-items-center gap-1"
        style={{ fontSize: '0.72rem', whiteSpace: 'nowrap', color: isDark ? '#94a3b8' : '#64748b' }}
      >
        <FontAwesomeIcon icon={faBolt} style={{ fontSize: '0.68rem', color: '#059669' }} />
        Atajos:
      </small>

      {/* Botones de atajos dinámicos */}
      {commands.map((cmd, idx) => {
        const label = cmd.vComando || cmd.label || '';
        const text = cmd.vTexto || cmd.text || '';
        const title = cmd.vTitulo || cmd.title || text;
        return (
          <button
            key={idx}
            type="button"
            title={title}
            onClick={() => onSelectCommand(text, false)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                onSelectCommand(text, true);
              }
            }}
            className="se-shortcut-pill shadow-none"
          >
            {label}
          </button>
        );
      })}

      {/* Botón para administrar / crear atajos */}
      <button
        type="button"
        title="Administrar o crear atajos"
        onClick={() => setIsModalOpen(true)}
        className="se-shortcut-pill-add shadow-none"
      >
        <FontAwesomeIcon icon={faPlus} style={{ fontSize: '0.62rem' }} />
        <span>Atajo</span>
      </button>

      {isModalOpen && (
        <ManageShortcutsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          commands={commands}
          onReload={onReload}
        />
      )}
    </div>
  );
};

export default TicketQuickCommands;


